export default "__VITE_ASSET__DgeQZMlt__"